import { render } from "./MyTracks.vue?vue&type=template&id=347212e8"
import script from "./MyTracks.vue?vue&type=script&lang=js"
export * from "./MyTracks.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__